<script lang="ts" setup>
const props = defineProps({
	action: {
		type: Function,
	},
	size: {
		type: Number,
		required: true,
	},
})

const emit = defineEmits(['on-click'])

function onClick($event: any) {
	emit('on-click', { $event })

	if (props.action === undefined) {
		return
	}

	props.action()
}
</script>
<template>
	<span
		class="bs-member-icon-button"
		@click="onClick"
		:style="`--data-size:${size}px`"
	>
		<slot />
	</span>
</template>
